import { companyActions } from './actions';
import { companyMutations } from './mutations';
import { companyGetters } from './getters';

const state = {
    company: {}
};
const actions = { ...companyActions };
const mutations = { ...companyMutations };
const getters = { ...companyGetters };


// eslint-disable-next-line import/prefer-default-export
export const companyStore = {
    state, actions, mutations, getters,
};
